module.exports = __webpack_public_path__ + "static/media/journey-to-the-west.68dfc8e8.gif";